import { warn as m } from "./util.js";
function F(r, t) {
  return H(r) || O(r, t) || T(r, t) || M();
}
function M() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O(r, t) {
  var e = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (e != null) {
    var i, n, u, a, o = [], f = !0, p = !1;
    try {
      if (u = (e = e.call(r)).next, t !== 0) for (; !(f = (i = u.call(e)).done) && (o.push(i.value), o.length !== t); f = !0) ;
    } catch (s) {
      p = !0, n = s;
    } finally {
      try {
        if (!f && e.return != null && (a = e.return(), Object(a) !== a)) return;
      } finally {
        if (p) throw n;
      }
    }
    return o;
  }
}
function H(r) {
  if (Array.isArray(r)) return r;
}
function R(r) {
  return Y(r) || W(r) || T(r) || U();
}
function U() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function T(r, t) {
  if (r) {
    if (typeof r == "string") return w(r, t);
    var e = Object.prototype.toString.call(r).slice(8, -1);
    if (e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set") return Array.from(r);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return w(r, t);
  }
}
function W(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
}
function Y(r) {
  if (Array.isArray(r)) return w(r);
}
function w(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, i = new Array(t); e < t; e++) i[e] = r[e];
  return i;
}
var g = 1e-4, E = function(t, e) {
  return [0, 3 * t, 3 * e - 6 * t, 3 * t - 3 * e + 1];
}, j = function(t, e) {
  return t.map(function(i, n) {
    return i * Math.pow(e, n);
  }).reduce(function(i, n) {
    return i + n;
  });
}, C = function(t, e) {
  return function(i) {
    var n = E(t, e);
    return j(n, i);
  };
}, D = function(t, e) {
  return function(i) {
    var n = E(t, e), u = [].concat(R(n.map(function(a, o) {
      return a * o;
    }).slice(1)), [0]);
    return j(u, i);
  };
}, I = function() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
    e[i] = arguments[i];
  var n = e[0], u = e[1], a = e[2], o = e[3];
  if (e.length === 1)
    switch (e[0]) {
      case "linear":
        n = 0, u = 0, a = 1, o = 1;
        break;
      case "ease":
        n = 0.25, u = 0.1, a = 0.25, o = 1;
        break;
      case "ease-in":
        n = 0.42, u = 0, a = 1, o = 1;
        break;
      case "ease-out":
        n = 0.42, u = 0, a = 0.58, o = 1;
        break;
      case "ease-in-out":
        n = 0, u = 0, a = 0.58, o = 1;
        break;
      default: {
        var f = e[0].split("(");
        if (f[0] === "cubic-bezier" && f[1].split(")")[0].split(",").length === 4) {
          var p = f[1].split(")")[0].split(",").map(function(c) {
            return parseFloat(c);
          }), s = F(p, 4);
          n = s[0], u = s[1], a = s[2], o = s[3];
        } else
          m(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", e);
      }
    }
  m([n, a, u, o].every(function(c) {
    return typeof c == "number" && c >= 0 && c <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", e);
  var y = C(n, a), l = C(u, o), h = D(n, a), A = function(v) {
    return v > 1 ? 1 : v < 0 ? 0 : v;
  }, d = function(v) {
    for (var z = v > 1 ? 1 : v, b = z, S = 0; S < 8; ++S) {
      var x = y(b) - z, B = h(b);
      if (Math.abs(x - z) < g || B < g)
        return l(b);
      b = A(b - x / B);
    }
    return l(b);
  };
  return d.isStepper = !1, d;
}, L = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.stiff, i = e === void 0 ? 100 : e, n = t.damping, u = n === void 0 ? 8 : n, a = t.dt, o = a === void 0 ? 17 : a, f = function(s, y, l) {
    var h = -(s - y) * i, A = l * u, d = l + (h - A) * o / 1e3, c = l * o / 1e3 + s;
    return Math.abs(c - y) < g && Math.abs(d) < g ? [y, 0] : [c, d];
  };
  return f.isStepper = !0, f.dt = o, f;
}, _ = function() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
    e[i] = arguments[i];
  var n = e[0];
  if (typeof n == "string")
    switch (n) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return I(n);
      case "spring":
        return L();
      default:
        if (n.split("(")[0] === "cubic-bezier")
          return I(n);
        m(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", e);
    }
  return typeof n == "function" ? n : (m(!1, "[configEasing]: first argument type should be function or string, instead received %s", e), null);
};
export {
  I as configBezier,
  _ as configEasing,
  L as configSpring
};
